import queryString from 'query-string'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Rdrct } from 'src/navigation/Lnk'
import { homeUrl } from 'src/navigation/urls'
import { getReportDownload } from 'src/redux/actions/data/reportDownloads.actions'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'

const Downloads: React.FC = () => {
  // download report and navigate to home page

  // get report id from url
  const location = useSelector(selectLocationFromState)
  const reportId = queryString.parse(location.search)?.reportId as string

  const dispatch = useDispatch()
  if (reportId) {
    dispatch(getReportDownload(reportId))
  }
  return <Rdrct to={homeUrl()} />
}

export default Downloads
